module.exports = __webpack_public_path__ + "static/fonts/PingFang-Regular.75225b2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/css/PingFang-Regular.ttf
// module id = dBOu
// module chunks = 1